import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import store from '@/store';
import { MENU_VISIBLE } from '@/store/actions/configurations';
import { isAuth, logoutUser } from "@/services/auth";
import WDropdown from "@/components/wrapper/sort-dropdown.vue";
import i18n, { DEFAULT_LOCALE, switchLanguageAsync } from "@/i18n";
import { LangsEnum } from '@/i18n/langsEnum';
var Header = /*#__PURE__*/function (_Vue) {
  function Header() {
    var _this;
    _classCallCheck(this, Header);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Header, [].concat(args));
    _defineProperty(_this, "logo", void 0);
    _defineProperty(_this, "languagesDropdownItems", []);
    return _this;
  }
  _inherits(Header, _Vue);
  return _createClass(Header, [{
    key: "mounted",
    value: function mounted() {
      this.languagesDropdownItems = [{
        key: LangsEnum.EN,
        icon: LangsEnum.EN
      }, {
        key: LangsEnum.FR,
        icon: LangsEnum.FR
      }, {
        key: LangsEnum.DE,
        icon: LangsEnum.DE
      }, {
        key: LangsEnum.ES,
        icon: LangsEnum.ES
      }];
      var userLang = i18n.global.locale || DEFAULT_LOCALE;
      this.languagesDropdownItems.forEach(function (item) {
        return item.isSelected = item.key === userLang;
      });
    }
  }, {
    key: "onLangChanges",
    value: function onLangChanges(key) {
      var selectedLang;
      var selectedLangIndex;
      this.languagesDropdownItems.forEach(function (item, index) {
        if (item.key === key) {
          item.isSelected = true;
          selectedLang = item;
          selectedLangIndex = index;
        } else {
          item.isSelected = false;
        }
      });
      this.languagesDropdownItems[selectedLangIndex] = selectedLang; // Due to javascript limitation, we need to force changes detection by reassigning object.
      switchLanguageAsync(key);
    }
    /**
     * Create the default logo if no logo is given
     */
  }, {
    key: "logoPath",
    get: function get() {
      return this.logo;
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      store.dispatch(MENU_VISIBLE, !store.getters.isMenuVisible);
    }
  }]);
}(Vue);
__decorate([Prop({
  default: require('./assets/logo_new.png')
})], Header.prototype, "logo", void 0);
Header = __decorate([Options({
  components: {
    WDropdown: WDropdown
  },
  methods: {
    isAuth: isAuth,
    logoutUser: logoutUser
  },
  data: function data() {
    return {
      loading: true,
      transitionBack: false,
      routeActive: true
    };
  },
  computed: {
    isMenuVisible: function isMenuVisible() {
      return store.getters.isMenuVisible;
    }
  }
})], Header);
export default Header;